import * as A from "fp-ts/Array";
import { fromTraversable, Lens } from "monocle-ts";
import { extract } from "./RicosContentAPI/extract";
import { isDraftContent, isRichContent } from "./types/contentTypes";
function getContentLength(content) {
  if (isDraftContent(content)) {
    return getDraftTextLength(content);
  } else if (isRichContent(content)) {
    return getRichContentTextLength(content);
  }
  return NaN;
}
function getRichContentTextLength(content) {
  return extract(content.nodes ?? []).map(({ textData }) => textData?.text || "").get().reduce((count, line) => count + line.length, 0);
}
function getDraftTextLength(content) {
  const blocksLens = Lens.fromProp()("blocks");
  const blockTraversal = fromTraversable(A.array)();
  const textLens = Lens.fromProp()("text");
  return blocksLens.composeTraversal(blockTraversal).composeLens(textLens).asFold().getAll(content).reduce((count, line) => count + line.length, 0);
}
export {
  getContentLength
};
//# sourceMappingURL=getContentLength.js.map
